import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiX } = FiIcons;

const ComparisonTable = () => {
  const tableData = [
    { feature: "Price/month", postifyr: "$35", hootsuite: "$99", buffer: "$60", sprout: "$199" },
    { feature: "Unlimited posts", postifyr: true, hootsuite: true, buffer: false, sprout: true },
    { feature: "Viral campaigns", postifyr: "✅ FREE", hootsuite: false, buffer: false, sprout: false },
    { feature: "Team members", postifyr: "2-5", hootsuite: "$99 each", buffer: "1", sprout: "$199 each" },
    { feature: "AI features", postifyr: true, hootsuite: "Limited", buffer: false, sprout: true },
    { feature: "Setup time", postifyr: "5 min", hootsuite: "30+ min", buffer: "10 min", sprout: "60+ min" },
    { feature: "Per-user fees", postifyr: false, hootsuite: true, buffer: true, sprout: true },
    { feature: "Contract required", postifyr: false, hootsuite: "Annual", buffer: "Monthly", sprout: "Annual" }
  ];

  const RenderCell = ({ value, isCheck }) => {
      if (value === true) return <SafeIcon icon={FiCheck} className="text-brand-teal text-xl mx-auto" />;
      if (value === false) return <SafeIcon icon={FiX} className="text-gray-300 text-xl mx-auto" />;
      return <span>{value}</span>;
  };

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mb-6">
            See Why Smart Entrepreneurs Choose Postifyr
          </h2>
        </motion.div>

        {/* Table */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="overflow-hidden bg-white rounded-2xl shadow-xl border border-gray-200"
        >
          <div className="overflow-x-auto">
            <table className="w-full min-w-[800px]">
              <thead>
                <tr className="bg-brand-navy text-white">
                  <th className="text-left p-6 font-bold w-1/4">Feature</th>
                  <th className="text-center p-6 bg-brand-teal font-bold w-1/5 text-xl relative">
                    Postifyr
                    <div className="absolute -top-2 right-2 bg-brand-yellow text-brand-navy text-[10px] px-2 py-0.5 rounded-full uppercase tracking-wide">Winner</div>
                  </th>
                  <th className="text-center p-6 font-bold w-1/5 opacity-80">Hootsuite</th>
                  <th className="text-center p-6 font-bold w-1/5 opacity-80">Buffer</th>
                  <th className="text-center p-6 font-bold w-1/5 opacity-80">Sprout</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr 
                    key={index} 
                    className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} border-b border-gray-100 last:border-0`}
                  >
                    <td className="p-5 font-semibold text-brand-navy pl-8">{row.feature}</td>
                    <td className="p-5 text-center font-bold text-brand-teal bg-brand-teal/5 border-x border-brand-teal/10">
                      <RenderCell value={row.postifyr} />
                    </td>
                    <td className="p-5 text-center text-gray-600"><RenderCell value={row.hootsuite} /></td>
                    <td className="p-5 text-center text-gray-600"><RenderCell value={row.buffer} /></td>
                    <td className="p-5 text-center text-gray-600"><RenderCell value={row.sprout} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </motion.div>

        {/* Callout Box */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 bg-brand-yellow rounded-2xl p-8 text-center max-w-2xl mx-auto shadow-lg"
        >
          <div className="flex items-center justify-center mb-4 text-brand-navy">
            <span className="text-2xl mr-3">💡</span>
            <h3 className="text-xl font-bold">Quick Math:</h3>
          </div>
          <div className="space-y-2 text-brand-navy/80 text-lg">
            <p>Hootsuite with 3 users = <span className="font-bold">$297/month</span></p>
            <p>Postifyr with 5 users = <span className="font-bold">$35/month</span></p>
          </div>
          <div className="mt-6 pt-6 border-t border-brand-navy/10">
            <p className="text-brand-navy text-2xl font-bold mb-6">
                You save $262/month = $3,144/year
            </p>
            <a 
              href="https://dashboard.postifyr.com/rsa176125959b2e527cd97c7b79622c6fdb?ref=comparison"
              className="inline-block bg-brand-teal text-white font-bold px-8 py-3 rounded-xl hover:bg-brand-navy transition-colors shadow-md"
            >
              Start Saving Today →
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ComparisonTable;